import { WidgetType } from '@shared/enums';

export const noWidget = { type: WidgetType.None };

export const mobileTaxWidgets: WidgetType[] = [
  WidgetType.Form1099Ready,
  WidgetType.Form1099Soon,
  WidgetType.Form1099When,
  WidgetType.FormW2Ready,
  WidgetType.FormW2Soon,
  WidgetType.FormW2When,
];
